import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "../../src/styles/login.scss";
import axios from "axios";
import LoginNavbar from "./loginNavbar";
import { getSessionEndedMessage, login } from "../utils/auth";
import { apiHost } from "../api/apiClient";
import { Helmet } from "react-helmet";
import { setErrorMessage } from "../reducers/actions";
import visionTrakLogo from "../Assets/visiontrak-logo-colored.png";

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      rememberpwd: false,
      errorUser: false,
      errorpass: false,
      error: false,
      loginMessage: "",
      sessionEndedMessage: "",
    };
  }

  componentDidMount() {
    const sessionEndedMessage = getSessionEndedMessage();
    if (sessionEndedMessage) {
      this.setState({ sessionEndedMessage });
    }
  }

  handleUserChange = (evt) => {
    this.setState({
      username: evt.target.value,
    });
  };

  handlePassChange = (evt) => {
    this.setState({
      password: evt.target.value,
    });
  };

  handlerememberPwd = (e) => {
    this.setState({
      rememberpwd: e.target.value
    })
  }

  handleSubmit = async (evt) => {
    var jwtDecode = require("jwt-decode");
    evt.preventDefault();
    const validate = this.handleValidation();
    if (validate) {
      this.setState({ loginMessage: "", sessionEndedMessage: "" });
      try {
        const response = await axios.post(`${apiHost}/api/auth/login`, {
          Email: this.state.username,
          Password: this.state.password,
        });
        console.log("response from login", response);
        if (response.status == "200") {
          login(response.data.token, response.data.user.userName);
          localStorage.setItem("accountDisplayName", response.data.user.displayName || response.data.user.userName || "");
          localStorage.setItem("accountEmail", response.data.user.email || "");
          this.props.setErrorMessageAction("");
          this.setState({ loginMessage: "", sessionEndedMessage: "" });
          localStorage.removeItem("customer");
          this.props.history.push("/home");
          console.log("👉 Returned data:", response.data.token);
          var token = response.data.token;

          var decoded = jwtDecode(token);
          localStorage.setItem("role", decoded.role);
          localStorage.setItem("userId", decoded.nameid);

          console.log(decoded);
          window.location.reload();
        }
      } catch (e) {
        const loginMessage = this.getLoginErrorMessage(e);
        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ loginMessage, sessionEndedMessage: "" });
      }
    }
  };

  getLoginErrorMessage = (error) => {
    if (!error.response) {
      return "Invalid login";
    }

    const { status, data } = error.response;

    if (typeof data === "string" && data.trim()) {
      return data;
    }

    if (status == "401") {
      return "Invalid login";
    }

    if (data && typeof data === "object") {
      return data.statusResponse || data.message || data.detail || data.title || "Invalid login";
    }

    return "Invalid login";
  };

  handleValidation = () => {
    if (!this.state.username) {
      this.setState({ errorUser: true });
      setTimeout(() => {
        this.setState({ errorUser: true });
      }, 3000);
      return false;
    }

    if (!this.state.password) {
      this.setState({ errorPass: true });
      setTimeout(() => {
        this.setState({ errorPass: true });
      }, 3000);
      return false;
    }

    return true;
  };
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Login </title>
        </Helmet>
        <LoginNavbar></LoginNavbar>

        <div className="loginPage">
          <video
            className="loginVideoBackground"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-hidden="true"
          >
            <source src="/videos/login-background.webm" type="video/webm" />
            <source src="/videos/login-background.mp4" type="video/mp4" />
          </video>
          <div className="loginVideoOverlay"></div>
          <div className="loginWrapper">
            <div className="loginHeader">
              <img
                className="loginLogo"
                src={visionTrakLogo}
                alt="VisionTrak"
              />
              <h1>Login.</h1>
              <p>Sign in to continue to AssetTrak.</p>
              {this.state.loginMessage && (
                <p className="error-msg">{this.state.loginMessage}</p>
              )}
              {!this.state.loginMessage && this.state.sessionEndedMessage && (
                <p className="error-msg">{this.state.sessionEndedMessage}</p>
              )}
            </div>
            <div className="loginForm">
              <form className="form" onSubmit={this.handleSubmit}>
                <div className="loginInput">
                  <div className="loginInputLeft">
                    <label>Email</label>
                  </div>
                  <div className="loginInputRight">
                    <input
                      type="text"
                      data-test="username"
                      value={this.state.username}
                      onChange={this.handleUserChange}
                      autoComplete="username"
                    />
                    <div className="error-msg">
                      {this.state.errorUser && (
                        <p>The email field is required.</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="loginInput">
                  <div className="loginInputLeft">
                    <label>Password</label>
                  </div>
                  <div className="loginInputRight">
                    <input
                      type="password"
                      data-test="password"
                      value={this.state.password}
                      onChange={this.handlePassChange}
                      autoComplete="current-password"
                    />
                    <div className="error-msg">
                      {this.state.errorPass && (
                        <p>The password field is required.</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="loginCheckbox">
                  <div className="loginInputLeft">
                    <input type="checkbox" value={this.state.rememberpwd} onChange={this.handlerememberPwd}></input>
                  </div>
                  <div className="loginInputRight">
                    <p>Remember me?</p>
                  </div>
                </div>
                <div className="loginBtnContainer">
                  <div className="loginBtn">
                    <input type="submit" value="Log in" data-test="submit" />
                  </div>
                </div>
                <div className="loginHelpLink">
                  <Link to="/forgot-password">Forgot password?</Link>
                </div>
              </form>
            </div>
            <div className="loginFooter">
                <p>&copy; {new Date().getFullYear()} - Vision Trak Rentals Pty Ltd </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
